import React from 'react';

import { ReactComponent as Lock } from 'assets/icons/lock.svg';
import { ReactComponent as JavelinPaymentsLogo } from 'assets/icons/logo-javelinpayments.svg';
import TEXT from 'locales/en/cart';

const Header = ({ title = '' }) => (
  <div data-testid="header" className="hidden lg:block">
    <h1 className="lg:text-4xl font-bold text-javelin-gray-dark mb-2 h-11 truncate">
      {title}
    </h1>
    <div className="inline-flex items-center text-opacity-60 text-javelin-gray-dark mt-2">
      <Lock className="w-3 h-3 fill-current self-start" />
      <p className="text-xs ml-2 mr-0.5">{TEXT.subheader}</p>
      <JavelinPaymentsLogo className="h-3 w-auto fill-current" />
    </div>
  </div>
);

export default Header;
